/** Matches backend `App\AppLib\Conf\InvoiceType`. */
export const InvoiceType = Object.freeze({
  Sale: "Sale",
  Purchase: "Purchase",
});

/** Combined invoices list filter. Use `All` to omit `invoicetype` on the API (both types). */
export const InvoiceListScope = Object.freeze({
  All: "all",
  Sale: InvoiceType.Sale,
  Purchase: InvoiceType.Purchase,
});

export const PersonsCount = [
  { value: 1, label: "1" },
  { value: 2, label: "2" },
  { value: 3, label: "3" },
  { value: 4, label: "4" },
  { value: 5, label: "5" },
  { value: 6, label: "6" },
];

export const DiscountTypes = [
  { value: "value", label: "Value" },
  { value: "%", label: "%" },
];
